module.exports = __webpack_public_path__ + "static/wade-431ad29999fce1bfc725187fdc476a79.jpg";